<template>
  <div id="Tab1">
    <div
      v-if="!disciplines || disciplines.length == 0"
      class="tab-content student-tabs-content"
    >
      <div class="d-flex align-items-center justify-content-center mt-5 py-5">
        <div class="align-items-center d-flex">
          <i class="fal big-icon mr-4 fa-folder-open text-gray-light" />
          <span class="text-gray-light message">
            No hay información de servicios disponible.
          </span>
        </div>
      </div>
    </div>
    <div v-if="disciplines" class="tab-content student-tabs-content">
      <div
        v-for="(discipline, disciplineIdx) in disciplines"
        :key="discipline.id"
      >
        <SectionTitle
          icon="fas fa-file-contract"
          :content="discipline.name"
          container-class="tag-badge-main-info mt-4 mb-4"
        />
        <div>
          <RowCard :id="'disciplines' + discipline.id">
            <RowCardItem
              v-for="(item, itemIdx) in discipline.value"
              :id="'disciplines-' + discipline.id + '-' + item.studentServiceId"
              :ref="'row-' + item.studentServiceId"
              :key="item.studentServiceId"
              @before-expand="
                loadCards(disciplineIdx, itemIdx, item.studentServiceId)
              "
            >
              <div slot="header" class="row">
                <div
                  class="col-md-3 col-sm-12 d-flex align-items-start flex-fill"
                >
                  <div class="icon-container">
                    <i class="fas fa-address-book text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Número de Referido:</span>
                    <span class="data-content">{{ item.referralNumber }}</span>
                  </div>
                </div>
                <div
                  class="col-md-3 col-sm-12 d-flex align-items-start flex-fill"
                >
                  <div class="icon-container">
                    <i class="fas fa-calendar-edit text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Fecha de Referido:</span>
                    <span class="data-content">
                      {{ item.referralDate | dateFormat }}
                    </span>
                  </div>
                </div>
                <div class="col-md-3 d-flex align-items-start flex-fill">
                  <div class="icon-container">
                    <i class="fas fa-ballot-check text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Modalidad:</span>
                    <span class="data-content">
                      {{ item.modalityTypeName }}
                    </span>
                  </div>
                </div>
                <div class="col-md-3 d-flex align-items-start flex-fill">
                  <div class="icon-container">
                    <i class="fas fa-clock text-orange" />
                  </div>
                  <div class="d-flex flex-column">
                    <span class="data-title">Frecuencia:</span>
                    <span class="data-content">
                      {{
                        item.frequencyTypeName + ' | ' + item.durationTypeName
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div slot="actions">
                <div class="row">
                  <div class="col-md-12">
                    <ActionButton
                      i="fas fa-file-search"
                      variant="outline-success m-2"
                      @click="goToServiceHistoryDocument(item, true, 'Tab1')"
                    >
                      Ver Documentos
                    </ActionButton>
                  </div>
                </div>
              </div>
              <div
                v-show="canShowCard(disciplineIdx, itemIdx)"
                slot="content"
                class="card-body p-0"
              >
                <div v-for="(card, cardIdx) in item.cards" :key="cardIdx">
                  <custom-callout
                    v-if="card.document && card.document.documentId"
                    ref="callout"
                    status-color="#fcc9c8"
                    border-color="#fcc9c8"
                    :has-toggle="true"
                    :controlled="true"
                    :opened="isOpen"
                    class="mt-2 mb-3"
                    @click:open="
                      () => {
                        isOpen = !isOpen;
                      }
                    "
                  >
                    <template #default>
                      <div class="row">
                        <!-- Status Card -->
                        <div class="col-md-2 m-0 p-0 border-right">
                          <div class="pr-4">
                            <custom-balloon
                              style="position: relative; left: -1em;"
                              class="mt-1 text-body px-4"
                              :text="card.admissionStatusName"
                              :background-color="
                                getStatusClass(card.admissionStatusId) + ' '
                              "
                            />
                          </div>
                          <div
                            v-if="card.lastStatusChanged"
                            class="col-md-12 d-flex flex-column"
                          >
                            <span class="data-title">Fecha de Estatus:</span>
                            <span class="data-content">
                              {{ card.lastStatusChanged | dateFormat }}
                            </span>
                          </div>
                        </div>

                        <!-- Main Card -->
                        <div class="col-md">
                          <div
                            v-if="card.admissionManagementRequestDropReason"
                            class="col-md-12 d-flex flex-column"
                          >
                            <span class="data-title">Razón:</span>
                            <span class="data-content">
                              {{ card.admissionManagementRequestDropReason }}
                            </span>
                          </div>

                          <!-- Cuerpo de la Card -->
                          <div>
                            <div class="row d-flex">
                              <div
                                class="col-md-3 col-sm-12 d-flex flex-column"
                              >
                                <span class="data-title">
                                  Fecha de Comienzo:
                                </span>
                                <span
                                  v-if="card.effectiveDateFrom"
                                  class="data-content"
                                >
                                  {{ card.effectiveDateFrom | dateFormat }}
                                </span>
                                <span v-else class="data-content">-</span>
                              </div>
                              <div class="col-md-3 col-sm-12 p-0 ml-3">
                                <div class="d-flex flex-column">
                                  <span class="data-title">Fecha Final:</span>
                                  <span
                                    v-if="card.effectiveDateTo"
                                    class="data-content"
                                  >
                                    {{ card.effectiveDateTo | dateFormat }}
                                  </span>
                                  <span v-else class="data-content">-</span>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-12 p-0 ml-3">
                                <div class="d-flex flex-row">
                                  <span class="data-title">
                                    Total de Visitas:
                                  </span>
                                  <span class="data-content ml-1">
                                    {{ card.admissionVisitCount || '-' }}
                                  </span>
                                </div>
                                <div class="row d-flex flex-row ml-2">
                                  <div class="col-md-6 col-sm-12 p-0 ml-n2">
                                    <span class="data-title">Min:</span>
                                    <span
                                      v-if="card.admissionVisitMinDate"
                                      class="data-content ml-1"
                                    >
                                      {{
                                        card.admissionVisitMinDate | dateFormat
                                      }}
                                    </span>
                                    <span v-else class="data-content ml-1">
                                      -
                                    </span>
                                  </div>
                                  <div class="col-md-6 col-sm-12 p-0 ml-n2">
                                    <span class="data-title">Max:</span>
                                    <span
                                      v-if="card.admissionVisitMaxDate"
                                      class="data-content ml-1"
                                    >
                                      {{
                                        card.admissionVisitMaxDate | dateFormat
                                      }}
                                    </span>
                                    <span v-else class="data-content ml-1">
                                      -
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row d-flex mt-3 ml-1 w-100">
                              <div class="col-md-6 p-0">
                                <div class="d-flex flex-column">
                                  <span class="data-title">Proveedor:</span>
                                  <span class="data-content">
                                    {{ card.companyName || '-' }}
                                  </span>
                                  <span
                                    v-if="card.locationName"
                                    class="data-content"
                                  >
                                    Lugar de Servicio:
                                    {{ card.locationName || '-' }}
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-6 p-0">
                                <div class="d-flex flex-column">
                                  <span class="data-title">Especialistas:</span>
                                  <span class="data-content">
                                    <b class="mr-1">Admisión:</b>
                                    {{
                                      card.admissionSpecialistFullName || '-'
                                    }}
                                  </span>
                                  <span class="data-content">
                                    <b class="mr-1">Servicio:</b>
                                    {{
                                      card.assignmentSpecialistFullName || '-'
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="
                                (card.admissionStatusId ==
                                  thrpiesAdmissionStatusCodes.ReferidoRechazado ||
                                  card.admissionStatusId ==
                                    thrpiesAdmissionStatusCodes.DevueltoEscuela) &&
                                  card.referralDenyComment
                              "
                              class="row d-flex mt-3 ml-1 w-100"
                            >
                              <div class="p-0">
                                <div class="d-flex flex-column">
                                  <span class="data-title">
                                    Comentario Rechazo:
                                  </span>
                                  <span class="data-content">
                                    {{ card.referralDenyComment }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Actions Card -->
                        <div class="col-md-2">
                          <div class="dropdown text-right mr-5 mt-3">
                            <button
                              class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span class="px-2">Acciones</span>
                              <i class="fa fa-angle-down" />
                            </button>
                            <div
                              class="dropdown-menu dropdown-menu-right py-2 mt-1"
                            >
                              <div
                                class="dropdown-item"
                                @click="
                                  goToStatusHistory(
                                    card.admissionId,
                                    item.referralNumber
                                  )
                                "
                              >
                                <em class="fa fa-history text-green pr-1" />
                                <span>Ver Historial</span>
                              </div>
                              <div
                                v-if="card.admissionVisitCount"
                                class="dropdown-item"
                                @click="openVisitDetails(card.admissionId)"
                              >
                                <em class="fa fa-clock text-green pr-1" />
                                <span>Ver Visitas</span>
                              </div>
                              <div
                                v-if="
                                  card.isIncompleteReferral == 1 ||
                                    card.admissionStatusId ==
                                      thrpiesAdmissionStatuses.ReferidoRechazado
                                "
                                class="dropdown-item"
                                @click="
                                  confirmResend(
                                    card.admissionId,
                                    item.studentServiceId,
                                    disciplineIdx,
                                    itemIdx
                                  )
                                "
                              >
                                <em class="fa fa-repeat-alt text-green pr-1" />
                                <span>Reenviar</span>
                              </div>
                              <div
                                v-if="canShowResendButton(card)"
                                class="dropdown-item"
                                @click="
                                  toggleRequireDocumentSection(card, true)
                                "
                              >
                                <em class="fa fa-repeat-alt text-green pr-1" />

                                <span>Reenviar</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template #edition>
                      <div class="pl-3 pr-3 pt-3 pb-3">
                        <div class="row white-bg ml-2">
                          <div class="col-md-12">
                            <span class="data-title">
                              <i class="fas fa-sync-alt text-green"></i>
                              Reenviar Referido para Coordinación de Servicio
                            </span>
                            <div class="data-content w-100">
                              <div class="row align-items-center">
                                <div class="col-md-4 col-sm-12">
                                  <span>
                                    <strong>Tipo de Documento:</strong>
                                    <div>
                                      Minuta de Acuerdo
                                    </div>
                                  </span>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                  <span>
                                    <strong>Archivo:</strong>
                                    <div>
                                      {{ card.document.filename }}
                                    </div>
                                  </span>
                                </div>
                                <div class="col-md-4 col-sm-12 text-right">
                                  <ActionButton
                                    class="mr-2"
                                    variant="success"
                                    i="fas fa-file-download"
                                    @click="
                                      onDownloadDocument(
                                        card.document.documentId
                                      )
                                    "
                                  ></ActionButton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </custom-callout>

                  <RowCardItemCard
                    v-else
                    :status="card.admissionStatusName"
                    :status-class="getStatusClass(card.admissionStatusId)"
                    :extra-expanded-section="card.showRequireDocumentSection"
                    :show-expanded-arrow-icon="card.document !== null"
                  >
                    <!-- Informacion que acompañana al estado -->

                    <div
                      v-if="
                        card.lastStatusChanged ||
                          card.admissionManagementRequestDropReason
                      "
                      slot="statusInfo"
                    >
                      <div class="row">
                        <div
                          v-if="card.lastStatusChanged"
                          class="col-md-12 d-flex flex-column"
                        >
                          <span class="data-title">Fecha de Estatus:</span>
                          <span class="data-content">
                            {{ card.lastStatusChanged | dateFormat }}
                          </span>
                        </div>
                        <div
                          v-if="card.admissionManagementRequestDropReason"
                          class="col-md-12 d-flex flex-column"
                        >
                          <span class="data-title">Razón:</span>
                          <span class="data-content">
                            {{ card.admissionManagementRequestDropReason }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Cuerpo de la Card -->
                    <div slot="body">
                      <div class="row d-flex">
                        <div class="col-md-3 col-sm-12 d-flex flex-column">
                          <span class="data-title">Fecha de Comienzo:</span>
                          <span
                            v-if="card.effectiveDateFrom"
                            class="data-content"
                          >
                            {{ card.effectiveDateFrom | dateFormat }}
                          </span>
                          <span v-else class="data-content">-</span>
                        </div>
                        <div class="col-md-3 col-sm-12 p-0 ml-3">
                          <div class="d-flex flex-column">
                            <span class="data-title">Fecha Final:</span>
                            <span
                              v-if="card.effectiveDateTo"
                              class="data-content"
                            >
                              {{ card.effectiveDateTo | dateFormat }}
                            </span>
                            <span v-else class="data-content">-</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12 p-0 ml-3">
                          <div class="d-flex flex-row">
                            <span class="data-title">Total de Visitas:</span>
                            <span class="data-content ml-1">
                              {{ card.admissionVisitCount || '-' }}
                            </span>
                          </div>
                          <div class="row d-flex flex-row ml-2">
                            <div class="col-md-6 col-sm-12 p-0 ml-n2">
                              <span class="data-title">Min:</span>
                              <span
                                v-if="card.admissionVisitMinDate"
                                class="data-content ml-1"
                              >
                                {{ card.admissionVisitMinDate | dateFormat }}
                              </span>
                              <span v-else class="data-content ml-1">-</span>
                            </div>
                            <div class="col-md-6 col-sm-12 p-0 ml-n2">
                              <span class="data-title">Max:</span>
                              <span
                                v-if="card.admissionVisitMaxDate"
                                class="data-content ml-1"
                              >
                                {{ card.admissionVisitMaxDate | dateFormat }}
                              </span>
                              <span v-else class="data-content ml-1">-</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row d-flex mt-3 ml-1 w-100">
                        <div class="col-md-6 p-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Proveedor:</span>
                            <span class="data-content">
                              {{ card.companyName || '-' }}
                            </span>
                            <span v-if="card.locationName" class="data-content">
                              Lugar de Servicio: {{ card.locationName || '-' }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-6 p-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Especialistas:</span>
                            <span class="data-content">
                              <b class="mr-1">Admisión:</b>
                              {{ card.admissionSpecialistFullName || '-' }}
                            </span>
                            <span class="data-content">
                              <b class="mr-1">Servicio:</b>
                              {{ card.assignmentSpecialistFullName || '-' }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          (card.admissionStatusId ==
                            thrpiesAdmissionStatusCodes.ReferidoRechazado ||
                            card.admissionStatusId ==
                              thrpiesAdmissionStatusCodes.DevueltoEscuela) &&
                            card.referralDenyComment
                        "
                        class="row d-flex mt-3 ml-1 w-100"
                      >
                        <div class="p-0">
                          <div class="d-flex flex-column">
                            <span class="data-title">Comentario Rechazo:</span>
                            <span class="data-content">
                              {{ card.referralDenyComment }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Acciones -->
                    <div slot="actions">
                      <div class="dropdown text-right mr-2">
                        <button
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="px-2">Acciones</span>
                          <i class="fa fa-angle-down" />
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right py-2 mt-1"
                        >
                          <div
                            class="dropdown-item"
                            @click="
                              goToStatusHistory(
                                card.admissionId,
                                item.referralNumber
                              )
                            "
                          >
                            <em class="fa fa-history text-green pr-1" />
                            <span>Ver Historial</span>
                          </div>
                          <div
                            v-if="card.admissionVisitCount"
                            class="dropdown-item"
                            @click="openVisitDetails(card.admissionId)"
                          >
                            <em class="fa fa-clock text-green pr-1" />
                            <span>Ver Visitas</span>
                          </div>
                          <div
                            v-if="
                              card.isIncompleteReferral == 1 ||
                                card.admissionStatusId ==
                                  thrpiesAdmissionStatuses.ReferidoRechazado
                            "
                            class="dropdown-item"
                            @click="
                              confirmResend(
                                card.admissionId,
                                item.studentServiceId,
                                disciplineIdx,
                                itemIdx
                              )
                            "
                          >
                            <em class="fa fa-repeat-alt text-green pr-1" />
                            <span>Reenviar</span>
                          </div>
                          <div
                            v-if="canShowResendButton(card)"
                            class="dropdown-item"
                            @click="toggleRequireDocumentSection(card, true)"
                          >
                            <em class="fa fa-repeat-alt text-green pr-1" />

                            <span>Reenviar</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      slot="extraExpandedSection"
                      v-if="card && card.showRequireDocumentSection"
                    >
                      <div class="row white-bg ml-2">
                        <div class="col-md-12">
                          <span class="data-title">
                            <i class="fas fa-sync-alt text-green"></i>
                            Reenviar Referido para Coordinación de Servicio
                          </span>
                          <div class="data-content w-100">
                            <div class="row align-items-center">
                              <div class="col-md-4 col-sm-12">
                                <span>
                                  <strong>Tipo de Documento:</strong>
                                  <div>
                                    Minuta de Acuerdo
                                  </div>
                                </span>
                              </div>
                              <div class="col-md-4 col-sm-12">
                                <customFileInput
                                  accept=".pdf"
                                  context="resend-referral"
                                  :admission-id="card.admissionId"
                                  :student-service-id="item.studentServiceId"
                                  :onDownload="() => {}"
                                  @input="
                                    (document) =>
                                      onDocumentsUploaded(card, item, document)
                                  "
                                />
                              </div>
                              <div class="col-md-4 col-sm-12 text-right">
                                <ActionButton
                                  v-if="!card.document"
                                  class="mr-2"
                                  variant="outline-danger"
                                  i="fas fa-times-circle"
                                  @click="cancelRequireDocumentSection(card)"
                                >
                                  Cancelar
                                </ActionButton>
                                <ActionButton
                                  v-else
                                  class="mr-2"
                                  variant="outline-success"
                                  i="fas fa-save"
                                  @click="
                                    submitRequireDocumentSection(
                                      card,
                                      item.studentServiceId,
                                      disciplineIdx,
                                      itemIdx
                                    )
                                  "
                                >
                                  Guardar
                                </ActionButton>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </RowCardItemCard>
                </div>
              </div>
            </RowCardItem>
          </RowCard>
        </div>
      </div>
    </div>
    <VisitDetailsHistory ref="visitDetailsHistoryModal" />
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import ActionButton from 'ActionButton';
import RowCard from '@/components/common/rowcard/RowCard';
import RowCardItem from '@/components/common/rowcard/RowCardItem';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import thrpiesAdmissionStatuses from '@/utils/constants/thrpiesAdmissionStatuses.js';
import VisitDetailsHistory from '../VisitDetailsHistory';
import alert from '@/mixin/alert.mixin';
import moment from 'moment';
import store from '@/store/index';
import CustomFileInput from 'CustomFileInput';
import documentTypes from '@/utils/constants/documentTypes.js';
import referralRejectionReason from '@/utils/constants/pei/referral/referralRejectionReason';
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import DocumentsService from '@/services/documents';

export default {
  name: 'Tab1',
  mixins: [alert],
  components: {
    ActionButton,
    SectionTitle,
    RowCard,
    RowCardItem,
    RowCardItemCard,
    VisitDetailsHistory,
    CustomFileInput,
    CustomCallout,
    CustomBalloon,
  },
  props: {
    academicYearId: {
      type: Number,
      default: 0,
    },
    shouldChoseYear: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    async academicYearId() {
      await this.getReferralAdmissionHistory();
    },
  },
  data() {
    return {
      thrpiesAdmissionStatuses: thrpiesAdmissionStatuses,
      disciplines: null,
      showVisitDetailHistory: false,
      showingCardsIdx: null,
      showingCardsIdxs: [],
      isOpen: false,
    };
  },
  filters: {
    dateFormat: function(value) {
      if (value) {
        return moment(value)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
    },
  },
  async mounted() {
    if (!this.shouldChoseYear) {
      await this.getReferralAdmissionHistory();
    }
  },
  methods: {
    async onDownloadDocument(documentId) {
      if (!documentId) {
        this.ShowToast('Error', 'El documento no existe.', 'error');
        return;
      }
      await DocumentsService.downloadFromServer(documentId).catch((err) => {
        const errorMsg =
          err.data && err.data.message
            ? err.data.message
            : err.response?.data?.message || 'Error al descargar el documento';
        this.ShowToast('Error', errorMsg, 'error');
      });
    },
    canShowResendButton(card) {
      return (
        card.admissionStatusId == thrpiesAdmissionStatuses.DevueltoEscuela &&
        (card.referralDenyReasonId ==
          referralRejectionReason.NoSeLogroContactarEncargados ||
          (this.hasSpecialPermissionToResendReferral &&
            card.referralDenyReasonId ==
              referralRejectionReason.LosEncargadosRechazaronOfrecimientoServicioTerapeutico))
      );
    },
    submitRequireDocumentSection(
      card,
      studentServiceId,
      disciplineIdx,
      itemIdx
    ) {
      const admissionId = card.admissionId;
      const documentType = documentTypes.MinutaDeAcuerdo;

      this.confirmResend(
        admissionId,
        studentServiceId,
        disciplineIdx,
        itemIdx,
        documentType,
        card.document
      );
    },
    cancelRequireDocumentSection(card) {
      this.toggleRequireDocumentSection(card, false);
    },
    onDocumentsUploaded(card, item, document) {
      this.$set(card, 'document', document);
    },
    toggleRequireDocumentSection(card, showRequireDocumentSection = null) {
      if (showRequireDocumentSection !== null) {
        this.$set(
          card,
          'showRequireDocumentSection',
          showRequireDocumentSection
        );
      } else {
        this.$set(
          card,
          'showRequireDocumentSection',
          !card.showRequireDocumentSection
        );
      }
    },
    goToStatusHistory(admissionId, referralNumber) {
      this.$router.push({
        name: 'pei-status-history',
        params: {
          admissionId: admissionId,
          referralNumber: referralNumber,
        },
      });
    },
    goToServiceHistoryDocument(item, allowAddDocument, tabToReturn) {
      const referralAdmissionId =
        item?.referralAdmissions[0]?.admissionId ?? null;
      this.$router.push({
        name: 'peiServiceHistoryDocuments',
        params: {
          studentServiceId: item.studentServiceId,
          allowAddDocument: allowAddDocument,
          tab: tabToReturn,
          resultSummary: item.hasSummary ? true : null,
          achievementSummary: item.referralHasAchievementSummary,
          interventionPlanId: item.interventionPlanId,
          admissionId: referralAdmissionId,
        },
      });
    },
    canShowCard(disciplineIdx, itemIdx) {
      return this.showingCardsIdxs.indexOf(disciplineIdx + '-' + itemIdx) >= 0;
    },
    openVisitDetails(id) {
      if (id != null && this.$refs.visitDetailsHistoryModal) {
        this.$refs.visitDetailsHistoryModal.open(id);
      }
    },
    loadCards(disciplineIdx, itemIdx, studentServiceId) {
      if (!this.disciplines[disciplineIdx].value[itemIdx].cards) {
        let self = this;
        let promise = new Promise((resolve) => {
          var queryStr = '';
          if (this.academicYearId > 0) {
            queryStr = `?academicYearId=${this.academicYearId}`;
          }
          self
            .$ApiGet(
              '/api/thrpyadmission/GetReferralAdmissionDetail/' +
                studentServiceId +
                queryStr
            )
            .then((res) => {
              const cards = res.data.map((card) => ({
                ...card,
                showRequireDocumentSection: false,
              }));
              self.$set(
                self.disciplines[disciplineIdx].value[itemIdx],
                'cards',
                cards
              );
              self.showingCardsIdxs.push(disciplineIdx + '-' + itemIdx);
              resolve(res.data);
            })
            .catch((err) => {
              self.response = err;
            });
        });
        return promise;
      }
    },
    async getReferralAdmissionHistory() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/thrpyadmission/ReferralAdmissionHistory/', {
            studentSieId: store.getters['$_student/StudentSie'],
            academicYearId: this.academicYearId,
          })
          .then((res) => {
            self.disciplines = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    getStatusClass(status) {
      switch (status) {
        case thrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
        case thrpiesAdmissionStatuses.DevueltoEscuela:
        case thrpiesAdmissionStatuses.ReferidoRechazado: {
          return 'brown';
        }
        case thrpiesAdmissionStatuses.ServicioRelacionadoActivo: {
          return 'green';
        }
        case thrpiesAdmissionStatuses.Asignado:
        case thrpiesAdmissionStatuses.Admitido:
        case thrpiesAdmissionStatuses.Vinculado: {
          return 'yellow';
        }
        case thrpiesAdmissionStatuses.NoVinculado:
        case thrpiesAdmissionStatuses.Alertas: {
          return 'pink';
        }
        case thrpiesAdmissionStatuses.AprobadoEnRemedioProvisional: {
          return 'violet';
        }
        default: {
          return 'orange';
        }
      }
    },
    async confirmResend(
      admissionId,
      studentServiceId,
      disciplineIdx,
      itemIdx,
      documentType = null,
      document = null
    ) {
      let response = await this.ShowCancelModal(
        'Confirmación',
        '¿Esta seguro que desea reenviar el referido para coordinación de servicio?',
        'Sí',
        'No'
      );

      if (response) {
        let self = this;

        // Construct FormData with the required fields
        const formData = new FormData();
        if (documentType !== null && document !== null) {
          formData.append('documentTypeId', documentType);
          formData.append('studentServiceId', studentServiceId);
        }
        formData.append('studentServiceId', studentServiceId ?? null);

        // Only append the file if present
        if (document && document instanceof File) {
          formData.append('file', document);
        }

        self
          .$ApiPost(
            'api/thrpyadmission/ResubmitAdmission/' + admissionId,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          )
          .then((res) => {
            if (res) {
              self.ShowToast('', 'Cambió de estatus exitosamente.', 'success');
              self.getReferralAdmissionHistory().then(() => {
                self.loadCards(disciplineIdx, itemIdx, studentServiceId);
              });
            }
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              self.ShowToast('', error.response.data.message, 'error');
            }
          });
      }
    },
  },
  computed: {
    thrpiesAdmissionStatusCodes() {
      return this.thrpiesAdmissionStatuses;
    },
    hasSpecialPermissionToResendReferral() {
      return this.$store.getters.HasPermission(
        'academic.pei.servicehistory.canresendreferral'
      );
    },
  },
};
</script>

<style scoped>
.icon-container {
  margin-top: 3px;
  margin-right: 12px;
}
.icon-container .far,
.icon-container .fas {
  font-size: 20px;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
.message {
  font-size: 16px;
}
.big-icon {
  font-size: 3em;
}
.white-bg {
  background-color: white;
  margin: -10px !important;
  padding: 1em;
}
</style>
